export default __webpack_public_path__ + "images/368364316b32bd058a094c03b9bfd80c-bgImg.png";